import upload from './FormNormalUpload.vue'
const FormNormalUpload = {
	install: function(Vue) {
		Vue.component('FormNormalUpload', upload)
	}
}
export default FormNormalUpload
